"use client"

import { APIProvider } from '@vis.gl/react-google-maps';
import { useJsApiLoader } from '@react-google-maps/api';
import React, { PropsWithChildren } from 'react';

// Stable reference so useJsApiLoader does not re-run internal logic on every parent re-render
const LIBRARIES: ("places")[] = ["places"];

function MapWrapper ({ children }: PropsWithChildren) {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: apiKey,
        libraries: LIBRARIES,
    });
    
    return (
        <APIProvider apiKey={apiKey}>
            {children}
        </APIProvider>
    );
};

export default MapWrapper;